/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import appStrings from 'common/app_strings';
import ProfileIntakeStepPage from 'pages/wholeme/molecules/profileIntakeStepPage/ProfileIntakeStepPage';
import WholeMeLoadingCircle from 'pages/wholeme/molecules/wholeMeLoadingCircle/WholeMeLoadingCircle';
import { excitedAgeGroups } from '../../../pages/excited_age_groups';
import SelectableItemsList from '../../../common/molecules/selectableItemsList/SelectableItemsList';
import MainImage from '../../../pages/wholeme/molecules/mainImage/MainImage';
import { useAppState } from '../../../providers/app-state/app-state-provider';

const {
  matchingQuiz: {
    header, subheader,
  },
} = appStrings;

const ProtegePreferencesPage = ({
  nextOnClick,
  prevOnClick,
  preferences,
  onSubFormSubmit,
  paginationMeta,
  exitIconOnClickOverride,
}) => {
  const [selectedFieldsState, setSelectedFieldsState] = useState(preferences?.age_group);
  const { platform } = useAppState();

  const saveField = () => {
    onSubFormSubmit('age_group', selectedFieldsState.length === 0 ? ['No Preference'] : selectedFieldsState);
    nextOnClick();
  };

  const onListChange = (fieldValue) => {
    if (fieldValue) {
      setSelectedFieldsState(fieldValue);
    } else {
      setSelectedFieldsState(preferences?.age_group);
    }
  };

  useEffect(() => {
    if (preferences?.age_group.length > 0) {
      setSelectedFieldsState(preferences.age_group);
    }
  }, [preferences]);

  return (
    <ProfileIntakeStepPage
      paginationMeta={paginationMeta}
      title={header}
      subtitle={subheader}
      prevButton={{ onClick: prevOnClick }}
      nextButton={{ onClick: saveField }}
      backgroundOverlay="/assets/profile/matching/protege-preferences-overlay.svg"
      isSplashPage
      splashPictureAlignsBottom
      exitIconOnClickOverride={exitIconOnClickOverride}
    >
      {!selectedFieldsState ? (
        <WholeMeLoadingCircle />
      ) : (
        <>
          <SelectableItemsList
            activeItems={selectedFieldsState}
            items={excitedAgeGroups}
            itemVariant="oval"
            onChange={(fieldValue) => onListChange(fieldValue)}
            selectionType="single"
            listStylesOverride={{
              width: '100%',
              display: 'inline-grid',
              gap: '15px',
            }}
          />
          <MainImage
            imageAlt="three orange triangles"
            imageSrc="./assets/profile/wholeMe/matching/three-orange-triangles.svg"
            imageStylesOverride={{ width: platform?.isNativePlatform ? 'calc(95% - 80px)' : 'calc:(70% - 80px)', paddingTop: '2rem' }}
          />
        </>
      )}
    </ProfileIntakeStepPage>
  );
};

export default ProtegePreferencesPage;
